/**
 * Fantasy Console 0 - Tab Panel Component
 *
 * Renders the content for the active editor tab using conditional rendering.
 * Tab state is preserved across switches via EditorTabStateContext.
 * Play and Library views are rendered separately by Layout.
 */

import { useCart } from '../../context/CartContext'
import { CodeEditorTab } from './CodeEditorTab'
import { SpriteEditorTab } from './SpriteEditorTab'
import { MapEditorTab } from './MapEditorTab'
import { SoundEditorTab } from './SoundEditorTab'
import styles from './TabPanel.module.css'

export function TabPanel() {
  const { activeTab } = useCart()

  return (
    <div className={styles.tabPanel}>
      {activeTab === 'code' && <CodeEditorTab />}
      {activeTab === 'sprites' && <SpriteEditorTab />}
      {activeTab === 'map' && <MapEditorTab />}
      {activeTab === 'sound' && <SoundEditorTab />}
    </div>
  )
}
